require('/ui/components/taskflow/contentArea/contentArea.module.scss.module.css');

export const container = "_container_zlpvt_1";
export const layoutHeaderWrapper = "_layout-header-wrapper_zlpvt_1";
